import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sas-management-oem-header',
  templateUrl: './sas-management-oem-header.component.html',
  styleUrls: ['./sas-management-oem-header.component.css'],
})
export class SasManagementOemHeaderComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.imgpath = environment.apps[this.clientId].oemConfig?.imgpath;
  }
}
